import { jsx as _jsx } from "react/jsx-runtime";
const MinusSvg = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M5 12H19",
            stroke: "#323338",
            strokeWidth: "2",
            strokeLinecap: "round"
        })
    });
export default MinusSvg;
